import { KeyValue } from '@angular/common';

// Used for keyvalue angular pipe: preserve original property order
export const noSort = (): number => {
  return 0;
};
